module.exports = __webpack_public_path__ + "static/media/sidebar_enrollment_help.9bb0b968.svg";